import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from './../../common/button/button.module';
import { IconModule } from './../../common/icon/icon.module';
import { SpinnerModule } from './../../common/spinner/spinner.module';
import { InputComponent } from './input.component';

@NgModule({
  declarations: [InputComponent],
  exports: [InputComponent],
  imports: [IconModule, CommonModule, ButtonModule, SpinnerModule],
})
export class InputModule {}

export { InputComponent } from './input.component';
